/* eslint-disable react/jsx-no-bind */
import { Button, Col, Drawer, Input, Row, Typography } from 'antd'
import AddAdminForm from 'container/AddAdminForm'
import AdminsTable from 'container/AdminsTable'
import { useState } from 'react'

const { Title } = Typography
const { Search } = Input

const AdminsPageLayout = () => {
	/**
	 * Local state for search query
	 */
	const [query, setQuery] = useState('')
	const [drawer, setDrawer] = useState(false)
	function openDrawer() {
		setDrawer(true)
	}
	function closeDrawer() {
		setDrawer(false)
	}

	return (
		<>
			<Row>
				<Col span={14}>
					<Title level={2}>Admins</Title>
				</Col>
				<Col span={2}>
					<Button type='primary' onClick={openDrawer}>
						Add Admin
					</Button>
				</Col>
				<Col span={8}>
					<Search
						onSearch={setQuery}
						placeholder='Search Admins Name/Email/Mobile'
						allowClear
						enterButton
					/>
				</Col>

				<Col span={24}>
					<AdminsTable query={query} />
				</Col>
			</Row>
			<Drawer
				title='Add Admin'
				placement='right'
				width='30vw'
				closable
				visible={drawer}
				onClose={closeDrawer}
				destroyOnClose
			>
				<AddAdminForm closeDrawer={closeDrawer} />
			</Drawer>
		</>
	)
}

export default AdminsPageLayout
